import AuthorsDropdown from '@/pages/dictionary/themes/list/parts/themes-filter/parts/authors-dropdown/AuthorsDropdown.vue'
import ClassesDropdown from '@/pages/common/dropdowns/class/ClassesDropdown.vue'
import SubjectsDropdown from '@/pages/common/dropdowns/subject/SubjectsDropdown.vue'

export const dropdownComponents = {
  AuthorsDropdown,
  ClassesDropdown,
  SubjectsDropdown,
}
